export default () => {
  const pathname = window.location.pathname;

  // Check for /discussion or /category/{wildcard}
  if (pathname.startsWith('/category') || pathname.startsWith('/discussion')) {
    return 4;
  }
  
  // Check for /sonatas or /sonatas/{wildcard}
  if (pathname === '/sonatas' || pathname.startsWith('/sonatas/')) {
    return 3;
  }
  
  // Check for /collections or /collections/{wildcard}
  if (pathname === '/collections' || pathname.startsWith('/collections/')) {
    return 2;
  }
  
  // Check for /about or /about/{wildcard}
  if (pathname === '/about' || pathname.startsWith('/about/')) {
    return 1;
  }
  
  // Default case
  return 0;
}